export enum TypeStateSign {
  OUT_FOR_SIGNATURE = 'OUT_FOR_SIGNATURE',
  SIGNED = 'SIGNED',
  CANCELLED = 'CANCELLED'
}
